import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { OrderDetails, OrderWrapper } from '../models/order.models';

@Injectable({
  providedIn: 'root',
})
export class CartOrderApiService {
  protected baseUrl = `${this.env.APIM_BASE_URL}/cart-v2-service`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  public getOrders(itemsToDisplay?: number): Observable<OrderWrapper> {
    let url = `${this.baseUrl}/orders`;

    if (itemsToDisplay >= 0) {
      url += `?amount=${itemsToDisplay}`;
    }

    return this.http.get<OrderWrapper>(url);
  }

  public getOrder(id: number): Observable<OrderDetails> {
    return this.http.get<OrderDetails>(`${this.baseUrl}/orders/${id}`);
  }
}
